import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/UI/Header';
import Footer from './components/UI/Footer';
import CookiePopup from './components/UI/CookiePopup';
import ProtectedRoute from './components/UI/ProtectedRoute';

import Home from './pages/Home';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import VerifyAccount from './pages/Auth/VerifyAccount';
import ForgotPassword from './pages/Auth/ForgotPassword';
import ResetPassword from './pages/Auth/ResetPassword';
import ArticleView from './pages/ArticleView';
import Category from './pages/Category';
import NotFound from './pages/NotFound';

import AdminDashboard from './pages/Dashboard/AdminDashboard';
import ManageArticles from './pages/Dashboard/Admin/ManageArticles';
import ManageComments from './pages/Dashboard/Admin/ManageComments';
import ManageUsers from './pages/Dashboard/Admin/ManageUsers';
import ManageCategories from './pages/Dashboard/Admin/ManageCategories';

import EditorDashboard from './pages/Dashboard/EditorDashboard';
import EditorManageArticles from './pages/Dashboard/Editor/ManageArticles';

import AuthorDashboard from './pages/Dashboard/AuthorDashboard';
import MyArticles from './pages/Dashboard/Author/MyArticles';
import CreateEditArticle from './pages/Dashboard/Author/CreateEditArticle';

import ReaderDashboard from './pages/Dashboard/ReaderDashboard';
import MyComments from './pages/Dashboard/Reader/MyComments';

import AboutUs from './pages/AboutUs';
import AboutProject from './pages/AboutProject';
import ContactUs from './pages/ContactUs';
import SocialMedia from './pages/SocialMedia';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Imprint from './pages/Imprint';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-background">
        <Header />
        <main className="flex-grow container mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify/:verificationCode" element={<VerifyAccount />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/articles/:slug" element={<ArticleView />} />
            <Route path="/category/:slug" element={<Category />} />

            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/about-project" element={<AboutProject />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/social-media" element={<SocialMedia />} />
            {/* Imprint, Privacy, Terms, etc. */}
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/imprint" element={<Imprint />} />

            {/* Admin */}
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute roles={['Admin']}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/manage-articles"
              element={
                <ProtectedRoute roles={['Admin']}>
                  <ManageArticles />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/manage-articles/add"
              element={
                <ProtectedRoute roles={['Admin']}>
                  <CreateEditArticle />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/manage-articles/edit/:id"
              element={
                <ProtectedRoute roles={['Admin']}>
                  <CreateEditArticle />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/manage-users"
              element={
                <ProtectedRoute roles={['Admin']}>
                  <ManageUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/manage-comments"
              element={
                <ProtectedRoute roles={['Admin']}>
                  <ManageComments />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/manage-categories"
              element={
                <ProtectedRoute roles={['Admin']}>
                  <ManageCategories />
                </ProtectedRoute>
              }
            />

            {/* Editor */}
            <Route
              path="/editor/dashboard"
              element={
                <ProtectedRoute roles={['Editor']}>
                  <EditorDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/editor/manage-articles"
              element={
                <ProtectedRoute roles={['Editor']}>
                  <EditorManageArticles />
                </ProtectedRoute>
              }
            />
            <Route
              path="/editor/manage-articles/add"
              element={
                <ProtectedRoute roles={['Editor']}>
                  <CreateEditArticle />
                </ProtectedRoute>
              }
            />
            <Route
              path="/editor/manage-articles/edit/:id"
              element={
                <ProtectedRoute roles={['Editor']}>
                  <CreateEditArticle />
                </ProtectedRoute>
              }
            />

            {/* Author */}
            <Route
              path="/author/dashboard"
              element={
                <ProtectedRoute roles={['Author']}>
                  <AuthorDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/author/my-articles"
              element={
                <ProtectedRoute roles={['Author']}>
                  <MyArticles />
                </ProtectedRoute>
              }
            />
            <Route
              path="/author/my-articles/add"
              element={
                <ProtectedRoute roles={['Author']}>
                  <CreateEditArticle />
                </ProtectedRoute>
              }
            />
            <Route
              path="/author/my-articles/edit/:id"
              element={
                <ProtectedRoute roles={['Author']}>
                  <CreateEditArticle />
                </ProtectedRoute>
              }
            />

            {/* Reader */}
            <Route
              path="/reader/dashboard"
              element={
                <ProtectedRoute roles={['Reader']}>
                  <ReaderDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reader/my-comments"
              element={
                <ProtectedRoute roles={['Reader']}>
                  <MyComments />
                </ProtectedRoute>
              }
            />

            {/* 404 Fallback */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <CookiePopup />
      </div>
    </Router>
  );
}

export default App;
